<div class="animated fadeIn rounded">
    <div class="card">
        <div class="card-header">
            <i class="fa fa-gift"></i> Detalle de Giftcard {{giftCard.giftCardNumber}}
            <div class="card-header-actions btn-group" dropdown placement="bottom left">
                <!-- <button class="btn btn-sm btn-outline-success" type="button"><i class="fa fa-regular fa-floppy-disk"></i>&nbsp;Guardar Orden</button> -->
                <button class="btn btn-sm btn-outline-success" type="button" (click)="printDocuments()">
                    <i class="fa fa-regular fa-file"></i>&nbsp;Imprimir Documentos
                </button>
                <button class="btn btn-sm btn-outline-success" type="button" [hidden]="!giftCard.creditNoteNumber"
                    (click)="printReturnDocuments()">
                    <i class="fa fa-regular fa-file"></i>&nbsp;Imprimir Documentos de Devolución
                </button>
                <button class="btn btn-sm btn-outline-primary" type="button" [disabled]="giftCard.creditNoteNumber"
                    (click)="returnGiftcard()">
                    <i class="fa fa-undo"></i>&nbsp;Devolver Giftcard
                </button>

            </div>
        </div>
        <div [hidden]="!giftCard.creditNoteNumber" class="alert alert-warning" role="alert">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Giftcard
                Devuelta
            </h4>
            <p>Esta giftcard ya se encuentra devuelta.</p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
            </div>
        </div>
        <div class="card-body">
            <div class="col-sm-6 col-lg-3">
                <div class="card">
                    <div class="card-body">
                        <div class="h4 m-0">{{giftCard.amount | currency: 'HNL ':'symbol' : '1.2-2'}}</div>
                        <div>Cantidad Actual</div>
                        <div class="progress progress-xs my-3">
                            <div class="progress-bar bg-success" role="progressbar" style="width: 25%"
                                [style.width.%]="this.giftCardMaxAmountPercent" aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                        <small class="text-muted">Cantidad Original: {{giftCardMaxAmount | currency: 'HNL ':'symbol' :
                            '1.2-2'}}</small>
                    </div>
                </div>
            </div>
            <accordion [isAnimated]="true">
                <accordion-group [isOpen]="true">
                    <span accordion-heading>
                        <i class='fa fa-users'></i> Información General
                    </span>

                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Código de Giftcard</b></label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" disabled [(ngModel)]="giftCard.giftCardNumber">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Fecha de Creación</b></label>
                        <div class="col-md-9">
                            <input type="datetime" class="form-control" disabled [value]="getTimeStamp()">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Código de Factura</b></label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" disabled [(ngModel)]="giftCard.invoiceNumber">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Código de Recibo </b></label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" disabled [(ngModel)]="giftCard.receiptCode">
                        </div>
                    </div>
                    <div class="form-group row" [hidden]="!giftCard.creditNoteNumber">
                        <label class="col-md-3 col-form-label"><b>Nota de Crédito </b></label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" disabled [(ngModel)]="giftCard.creditNoteNumber">
                        </div>
                    </div>
                </accordion-group>
                <pos-payment-details [payments]="payments"></pos-payment-details>
            </accordion>
        </div>
    </div>
</div>